import { useCallback, useState } from 'react';

import { fetchSendMessage } from '../../fetch/fetchSendMessage';
import { streamMessage } from '../../fetch/fetchSendMessageStream';

export default function useSendMessage() {
  const [isPending, setIsPending] = useState(false);

  const simpleAsk = useCallback(async (query, session_id) => {
    setIsPending(true);
    try {
      const response = await fetchSendMessage(query, session_id);
      return response;
    } finally {
      setIsPending(false);
    }
  }, []);

  const simpleAskStream = useCallback(async (query, session_id, { onFirstToken, onToken, onFinal, signal } = {}) => {
    setIsPending(true);
    try {
      await streamMessage({
        query,
        session_id,
        onFirstToken,
        onToken,
        onFinal,
        onError: () => {
          // Errors are propagated to the caller via the thrown error.
        },
        signal,
      });
    } finally {
      setIsPending(false);
    }
  }, []);

  return { simpleAsk, simpleAskStream, isPending };
}

